<div class="container my-3">
  <!-- <h1 class="mb-4">Add Warranty</h1> -->
  <form #form="ngForm" (ngSubmit)="addwarranty()" class="mt-4">
    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="name" class="form-label">Name</label>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control border border-dark" id="name" name="name"
          [(ngModel)]="addWarrantyRequest.Name" autocomplete="on" />
      </div>
    </div>
<!-- Commented on 12th may 2026 for the breadcrumb changes -->
     <!-- <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="name" class="form-label">Plant:</label>

      </div>

      <div class="col-sm-4">

        <select class="form-select border border-dark" name="plantid" (change)="getSelectedId($event)"
          [(ngModel)]="addWarrantyRequest.PlantId" #plantId="ngModel">
          <option [ngValue]="0" selected="true">
            Select Plant
          </option>
          <option *ngFor="let plant of plants" [value]="plant.Id">
            {{ plant.Name }}
          </option>
        </select>
      </div>
    </div>
  
    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">

        <label for="train" class="form-label">Train:</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select border border-dark" name="trainid" (change)="getSelectedTrain($event)"
          [(ngModel)]="addWarrantyRequest.TrainId">
          <option [ngValue]="0" selected="true"> Select Train </option>
        
          <option *ngFor="let train of allTrainList" [value]="train.Id">
            {{ train.Name }}
          </option>
        </select>
      </div>
    </div> -->

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="stage" class="form-label">Stage:</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select border border-dark" name="sategid" [(ngModel)]="addWarrantyRequest.Stage">
          <option [value]="trainDetails.Stages" [selected]="trainDetails.Stages">
            {{ trainDetails.Stages }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="type" class="form-label">Warranty Type:</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select border border-dark" name="type" [(ngModel)]="addWarrantyRequest.Type">
          <option *ngFor="let Wt of Wtypes" [value]="Wt.Id">
            {{ Wt.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label *ngIf="addWarrantyRequest.Type != 1" for="maximunfeedpress" class="form-label">Maximum Feed
          Pressure</label>
        <label *ngIf="addWarrantyRequest.Type == 1" for="maximunfeedpress" class="form-label">Maximum Permeate
          TDS</label>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control border border-dark" id="maximunfeedpress" name="maximunfeedpress"
          [(ngModel)]="addWarrantyRequest.MaxPermTds" autocomplete="on" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="mintemp" class="form-label">Minimum Temperature:</label>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control border border-dark" id="mintemp" name="mintemp"
          [(ngModel)]="addWarrantyRequest.MinTemp" autocomplete="on" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="maxtemp" class="form-label">Maximum Temperature:</label>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control border border-dark" id="maxtemp" name="maxtemp"
          [(ngModel)]="addWarrantyRequest.MaxTemp" autocomplete="on" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="minFeedTds" class="form-label">Minimum Feed TDS:</label>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control border border-dark" id="minFeedTds" name="minFeedTds"
          [(ngModel)]="addWarrantyRequest.MinFeedTds" autocomplete="on" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="MaxFeedTds" class="form-label">Maximum Feed TDS:</label>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control border border-dark" id="MaxFeedTds" name="MaxFeedTds"
          [(ngModel)]="addWarrantyRequest.MaxFeedTds" autocomplete="on" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="MinPermFlow" class="form-label">Minimum Perm Flow:</label>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control border border-dark" id="MinPermFlow" name="MinPermFlow"
          [(ngModel)]="addWarrantyRequest.MinPermFlow" autocomplete="on" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="MinPermFlow" class="form-label">Maximum Perm Flow:</label>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control border border-dark" id="MaxPermFlow" name="MaxPermFlow"
          [(ngModel)]="addWarrantyRequest.MaxPermFlow" autocomplete="on" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="notes" class="form-label">Notes:</label>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control border border-dark" id="Notes" name="Notes"
          [(ngModel)]="addWarrantyRequest.Notes" autocomplete="on" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left"></div>
      <div class="col-sm-4">
        <button type="submit" class="btn custom-buttons-btn">Create</button>
      </div>
    </div>
  </form>
</div>